import { useState } from 'react';
import { InputSwitch } from 'primereact/inputswitch';


export function PropertySwitch({propertyName, initialVal, label, id, onDone}) {
    const [val, setVal] = useState(initialVal);
    
    return (
        <>
            <label htmlFor={id + '-' + propertyName} style={{display: 'block'}}>{label}</label>
            <InputSwitch 
                inputId={id + '-' + propertyName}
                checked={val}
                name={propertyName}
                onChange={(e) =>{
                        setVal(e.value);
                        onDone(propertyName,e.value);
                    }
                }
            />
        </>
        
    )
}